import { useEffect, useState } from "react";

const navLinks = [
  { key: "home", label: "首页", href: "#top" },
  { key: "hot", label: "热点复盘", href: "#hot" },
  { key: "timeline", label: "完整时间线", href: "#timeline" },
  { key: "method", label: "前因后果", href: "#method" },
  { key: "media", label: "深度内容", href: "#media" },
  { key: "faq", label: "常见问题", href: "#faq" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("home");

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 40);
      const ids = ["top", "hot", "timeline", "method", "media", "faq"];
      let current = "home";
      for (const id of ids) {
        const el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top <= 120) {
          current = id;
        }
      }
      setActive(current);
    };
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={
        "fixed top-0 left-0 right-0 z-50 transition-all duration-300 " +
        (scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent")
      }
    >
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-[72px]">
          {/* 品牌 */}
          <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap" aria-label="在线吃瓜首页">
            <span
              className={
                "w-9 h-9 rounded-lg flex items-center justify-center " +
                (scrolled ? "bg-primary-500 text-background-50" : "bg-primary-500/90 text-background-50")
              }
            >
              <i className="ri-water-flash-line text-lg" aria-hidden="true"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span
                className={
                  "font-heading text-xl md:text-2xl font-extrabold tracking-tight " +
                  (scrolled ? "text-foreground-900" : "text-background-50")
                }
              >
                在线吃瓜
              </span>
              <span
                className={
                  "hidden md:block text-[10px] tracking-[0.2em] mt-1 " +
                  (scrolled ? "text-foreground-500" : "text-background-200")
                }
              >
                理清每一场瓜的来龙去脉
              </span>
            </span>
          </a>

          {/* 桌面导航 */}
          <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
            {navLinks.map((l) => (
              <a
                key={l.key}
                href={l.href}
                className={
                  "px-3.5 py-2 rounded-md text-sm whitespace-nowrap transition-colors " +
                  (active === l.key
                    ? scrolled
                      ? "text-primary-700 bg-primary-100/70 font-medium"
                      : "text-background-50 bg-background-50/15 font-medium"
                    : scrolled
                      ? "text-foreground-600 hover:text-primary-700 hover:bg-background-100"
                      : "text-background-100 hover:text-background-50 hover:bg-background-50/10")
                }
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href="#faq"
              className={
                "hidden md:inline-flex items-center gap-2 px-4 py-2 rounded-md text-sm whitespace-nowrap font-medium transition-colors " +
                (scrolled
                  ? "bg-secondary-100 text-secondary-900 hover:bg-secondary-200"
                  : "bg-background-50/10 text-background-100 border border-background-200 hover:bg-background-50/20")
              }
            >
              <i className="ri-question-line" aria-hidden="true"></i>
              投稿与线索
            </a>
            <a
              href="#subscribe"
              className={
                "inline-flex items-center gap-2 px-4 py-2 rounded-md text-sm whitespace-nowrap font-medium text-background-50 transition-colors " +
                (scrolled ? "bg-primary-500 hover:bg-primary-600" : "bg-primary-500 hover:bg-primary-600")
              }
            >
              订阅推送
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </a>

            {/* 移动端按钮 */}
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              className={
                "lg:hidden w-10 h-10 rounded-md flex items-center justify-center transition-colors " +
                (scrolled
                  ? "bg-background-100 text-foreground-800"
                  : "bg-background-50/15 text-background-50")
              }
              aria-label="打开菜单"
            >
              <i className={(open ? "ri-close-line" : "ri-menu-line") + " text-xl"} aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>

      {/* 移动端菜单 */}
      {open && (
        <nav
          className="lg:hidden bg-background-50 border-t border-background-200 px-4 pb-4 pt-2"
          aria-label="移动端导航"
        >
          <div className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <a
                key={l.key}
                href={l.href}
                onClick={() => setOpen(false)}
                className={
                  "px-3 py-2.5 rounded-md text-sm whitespace-nowrap transition-colors " +
                  (active === l.key
                    ? "text-primary-700 bg-primary-100/70 font-medium"
                    : "text-foreground-600 hover:bg-background-100")
                }
              >
                {l.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setOpen(false)}
              className="mt-1 px-3 py-2.5 rounded-md text-sm text-primary-700 bg-primary-100/70 font-medium whitespace-nowrap"
            >
              订阅推送
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}